<template>
  <div
    :class="{ required: data.required, disabled: data.disabled }"
    class="field">
    <div class="ui checkbox">
      <input
        type="checkbox"
        :name="data.hasOwnProperty('name') ? data.name : `checkbox-input-${_uid}`"
        v-model="input">
      <label v-html="$t(data.label)"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CheckboxInput',
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      required: false
    },
    functions: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      input: this.value
    }
  },
  computed: {
    shouldSetDefault () {
      return (
        this.functions &&
        this.functions.hasOwnProperty('shouldSetDefault') &&
        this.functions.shouldSetDefault(this)
      )
    }
  },
  watch: {
    input: {
      handler (value) {
        this.$emit('input', this.input)
      },
      immediate: true
    },
    value: {
      handler (newValue) {
        this.input = newValue
      },
      immediate: true
    }
  },
  mounted () {
    if (this.shouldSetDefault && this.data.hasOwnProperty('default')) {
      this.input = this.data.default
    }

    $('.ui.checkbox').checkbox()
  }
}
</script>

<style scoped>

</style>
